import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const accountExpenseDocument = async (documentId, numeroAsiento) => {
  const res = await axios.post(
    `${API_URL}/api/expense-documents/${documentId}/accounting`,
    { numeroAsiento },
    { headers: authHeaders() }
  );
  return res.data;
};
